import { DEFAULT_THEME_ID, type ThemeMode } from '@astral/shared';
import { astralCrimson } from './themes/astral-crimson.js';
import type { ColorScheme, Theme } from './tokens.js';

/**
 * Registry of available themes.
 *
 * Astral now ships ONE official visual identity, so only Astral Crimson is
 * registered — the alternate theme definitions are no longer imported, which
 * keeps them out of the runtime bundle now that the picker is gone. The
 * registry itself is intentionally retained: it is the extension point, and
 * `getTheme` still resolves any legacy stored id safely to the default.
 */
export const themes: Record<string, Theme> = {
  [astralCrimson.id]: astralCrimson,
};

export const DEFAULT_THEME = astralCrimson;

/** Look up a theme by id, falling back to the default. */
export function getTheme(themeId: string): Theme {
  return themes[themeId] ?? themes[DEFAULT_THEME_ID] ?? DEFAULT_THEME;
}

/** List all themes (for a future theme picker). */
export function listThemes(): Theme[] {
  return Object.values(themes);
}

/**
 * Resolve the concrete color scheme to render, given the user's chosen mode
 * and the current system/Telegram scheme.
 *  - dark / light : forced.
 *  - auto         : follow the system scheme.
 *  - custom       : reserved; currently follows the system scheme.
 */
export function resolveScheme(mode: ThemeMode, systemScheme: ColorScheme): ColorScheme {
  switch (mode) {
    case 'dark':
      return 'dark';
    case 'light':
      return 'light';
    case 'auto':
    case 'custom':
      return systemScheme;
    default:
      return 'dark';
  }
}
